/**
 * Query keys, built in one place.
 *
 * Keyed by token, so two links opened in two tabs do not share a cache entry -
 * they are different designs, and the token is the only thing that
 * distinguishes them.
 */
export const queryKeys = {
  review: {
    all: ['review'] as const,
    open: (token: string) => [...queryKeys.review.all, 'open', token] as const,
    case: (token: string) => [...queryKeys.review.all, 'case', token] as const,
    patientLink: (token: string) => [...queryKeys.review.all, 'patient-link', token] as const,
  },
  patient: {
    open: (token: string) => ['patient', 'open', token] as const,
  },
} as const;
